import * as TYPES from './personal-contacts-actiontypes';
import { persistStateToSession, getStateFromSession } from '../../webstorage';

// export const LOCAL_STORAGE_KEY = 'patient:personal-contacts:selectedContactId';
export const LOCAL_STORAGE_KEY_STRING = 'patient:personal-contacts:selectedContactId';

export const initialState = {
  personalContacts: [],
  // selectedContactId: getStateFromSession(LOCAL_STORAGE_KEY, null),
  selectedContactId: getStateFromSession(LOCAL_STORAGE_KEY_STRING, null),
  accessEnabled: null,
  accountUnlocked: null,
  passwordReset: null,
};

const addNewContactToContacts = (newContact, contacts) => {
  let isExisting = false;
  let newPersonalContacts = contacts.map(
    (contact) => {
      if (contact.contactId === newContact.contactId) {
        isExisting = true;
        return newContact;
      }
      return contact;
    }
  );
  if (!isExisting) {
    newPersonalContacts = contacts.slice();
    newPersonalContacts.push(newContact);
  }
  return newPersonalContacts;
};

const personalContactsReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.PERSONAL_CONTACTS_LOADED_SUCCESS:
      newState = { ...state, personalContacts: action.personalContacts };
      break;
    case TYPES.PERSONAL_CONTACT_LOADED_SUCCESS:
      newState = { ...state,
        personalContacts: addNewContactToContacts(action.personalContact, state.personalContacts),
      };
      break;
    case TYPES.PERSONAL_CONTACTS_SET_CONTACTID:
      newState = { ...state,
        selectedContactId: action.selectedContactId,
        accessEnabled: null,
      };
      persistStateToSession(LOCAL_STORAGE_KEY_STRING, newState.selectedContactId);
      break;
    case TYPES.PERSONAL_CONTACTS_ENABLED_ACCESS:
      newState = { ...state,
        personalContacts: addNewContactToContacts(action.personalContact, state.personalContacts),
        accessEnabled: true };
      break;
    case TYPES.PERSONAL_CONTACTS_DISABLED_ACCESS:
      newState = { ...state,
        personalContacts: addNewContactToContacts(action.personalContact, state.personalContacts),
        accessEnabled: false };
      break;
    case TYPES.PERSONAL_CONTACTS_UNLOCKED_ACCOUNT:
      newState = { ...state, accountUnlocked: true };
      break;
    case TYPES.PERSONAL_CONTACTS_PASSWORD_RESET:
      newState = { ...state,
        passwordReset: true,
        accountUnlocked: true };
      break;
    case TYPES.PERSONAL_CONTACTS_CLEAR_FLAGS:
      newState = { ...state,
        accessEnabled: null,
        accountUnlocked: null,
        passwordReset: null };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default personalContactsReducer;
